export default [
    {to: "/user/home", text: "总览", icon: "wq-home"},
    {to: "/user/message", text: "消息管理", type: "group", children: [
        {to: "/user/message/processing", text: "待发送", icon: "wq-processing"},
        {to: "/user/message/sending", text: "发送中", icon: "wq-sending"},
        {to: "/user/message/finish", text: "已完成", icon: "wq-finish"},
    ]},
    {to: "/user/balance", text: "财务管理", type: "group", children : [
        {to: "/user/balance/recharge", text:  "充值记录", icon: "wq-recharge"},
        {to: "/user/balance/consume", text: "消耗记录", icon: "wq-customer-consume"}
    ]},
    {to: "/user/developer", text: "开发者管理", type: "group", children : [
        {to: "/user/developer/info", text:  "开发者信息", icon: "wq-code"},
        {to: "/user/developer/ip", text: "IP白名单", icon: "wq-ip"},
        {to: "/user/developer/notify", text: "通知回调", icon: "wq-notify"}
    ]}
]
